export default __webpack_public_path__ + "static/media/RightArrow.62ff891b.svg";